import { createBrowserRouter, createRoutesFromElements, Route } from "react-router";
import { ConsoleLayout } from "../components/ConsoleLayout";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { PublicLayout } from "../components/PublicLayout";
import { NotFoundPage } from "../pages/NotFoundPage";
import { SignInPage } from "../pages/SignInPage";
import { SignUpPage } from "../pages/SignUpPage";
import { SignUpConfirmationPage } from "../pages/SignUpConfirmationPage";
import { ConsoleAccountPage } from "../pages/console/ConsoleAccountPage";
import { ConsoleAdminPage } from "../pages/console/ConsoleAdminPage";
import { ConsoleGlobalNetworkPage } from "../pages/console/ConsoleGlobalNetworkPage";
import { ConsoleLogsPage } from "../pages/console/ConsoleLogsPage";
import { ConsoleOverviewPage } from "../pages/console/ConsoleOverviewPage";
import { ConsoleServerDetailPage } from "../pages/console/ConsoleServerDetailPage";
import { ConsoleServersPage } from "../pages/console/ConsoleServersPage";
import { ConsoleStubPage } from "../pages/console/ConsoleStubPage";
import { ConsoleUsagePage } from "../pages/console/ConsoleUsagePage";
import { PUBLIC_ROUTE_ELEMENTS } from "./publicRoutes";

/**
 * The console shell sits behind a `lite` guard; individual console pages layer
 * their own minimum-access guards (admin pages require admin).
 */
export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<PublicLayout />}>
        {PUBLIC_ROUTE_ELEMENTS}
        <Route path="sign-in" element={<SignInPage />} />
        <Route path="sign-up" element={<SignUpPage />} />
        <Route path="sign-up/confirmation" element={<SignUpConfirmationPage />} />
      </Route>

      <Route
        path="console"
        element={
          <ProtectedRoute minimum="lite">
            <ConsoleLayout />
          </ProtectedRoute>
        }
      >
        <Route
          index
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleOverviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="servers"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleServersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="servers/:serverId"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleServerDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="subspaces"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleStubPage
                title="Subspaces"
                body="Manage spatial subspaces across your servers from one place."
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="state"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleStubPage
                title="State"
                body="Inspect persistent state written by your servers."
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="inference"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleStubPage
                title="Inference"
                body="Configure inference providers and tools available to your servers."
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="usage"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleUsagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="logs"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleLogsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="account"
          element={
            <ProtectedRoute minimum="lite">
              <ConsoleAccountPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin"
          element={
            <ProtectedRoute minimum="admin">
              <ConsoleAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/network"
          element={
            <ProtectedRoute minimum="admin">
              <ConsoleGlobalNetworkPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </>
  )
);
